import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { SectionAListLayer } from '../components/ImportQuestion/SectionAListLayer'

export const SectionAListPage = () => {
  return (
    <MasterLayout>
        <SectionAListLayer/>
    </MasterLayout>
  )
}
